// extracted by mini-css-extract-plugin
module.exports = {"ErrorModal":"ErrorModal_ErrorModal__1BgCU"};